import React, { useState } from 'react';
import './GameSetup.css';

function GameSetup({ onCreateGame, onCreateComputerGame, onJoinGame, onResumeGame, playerGames, error }) {
  const [joinCode, setJoinCode] = useState('');

  const handleJoin = (e) => {
    e.preventDefault();
    if (joinCode.trim()) {
      onJoinGame(joinCode.trim().toUpperCase());
    }
  };

  return (
    <div className="game-setup">
      <div className="setup-container">
        <h1>Math Facts Battleship</h1>
        <p className="subtitle">Practice math facts while playing battleship!</p>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="setup-options">
          <div className="setup-section">
            <h2>Play vs Computer</h2>
            <p>Practice against the AI opponent</p>
            <button onClick={onCreateComputerGame} className="btn-primary btn-computer">
              Play vs Computer
            </button>
          </div>

          <div className="divider">OR</div>

          <div className="setup-section">
            <h2>Create Multiplayer Game</h2>
            <p>Start a new game and invite a friend</p>
            <button onClick={onCreateGame} className="btn-primary">
              Create Game
            </button>
          </div>

          <div className="divider">OR</div>

          <div className="setup-section">
            <h2>Join Existing Game</h2>
            <p>Enter the game code to join</p>
            <form onSubmit={handleJoin}>
              <input
                type="text"
                placeholder="Enter game code"
                value={joinCode}
                onChange={(e) => setJoinCode(e.target.value)}
                maxLength={6}
                className="game-code-input"
              />
              <button type="submit" className="btn-primary">
                Join Game
              </button>
            </form>
          </div>
        </div>

        {playerGames && playerGames.length > 0 && (
          <div className="existing-games">
            <h2>Your Active Games</h2>
            <div className="games-list">
              {playerGames.map(game => (
                <div key={game.gameCode} className="game-item">
                  <div className="game-info">
                    <span className="game-code">{game.gameCode}</span>
                    <span className={`game-phase ${game.phase}`}>{game.phase}</span>
                    {game.isYourTurn && <span className="your-turn">Your Turn!</span>}
                    {game.winner && (
                      <span className={`game-winner ${game.winner === 'you' ? 'won' : 'lost'}`}>
                        {game.winner === 'you' ? 'Won' : 'Lost'}
                      </span>
                    )}
                  </div>
                  <div className="game-details">
                    {game.isComputerGame ? (
                      <span>vs Computer</span>
                    ) : (
                      <>
                        <span>{game.isHost ? 'Host' : 'Guest'}</span>
                        <span>{game.playerCount}/2 players</span>
                      </>
                    )}
                    <span>{new Date(game.updatedAt).toLocaleString()}</span>
                  </div>
                  <button 
                    onClick={() => onResumeGame(game.gameCode)}
                    className="btn-secondary"
                  >
                    Resume →
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="instructions">
          <h3>How to Play:</h3>
          <ol>
            <li>Place your ships on any cells</li>
            <li>Solve math problems to attack opponent's cells</li>
            <li>Take turns attacking your opponent's board</li>
            <li>First to sink all enemy ships wins!</li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default GameSetup;